import { motion } from "motion/react";
import type { ReactNode } from "react";

const ease = [0.16, 1, 0.3, 1] as const;

export function StatCard({
  icon,
  value,
  label,
  valueClassName,
  index = 0,
}: {
  icon: ReactNode;
  value: string;
  label: string;
  valueClassName?: string;
  index?: number;
}): ReactNode {
  return (
    <motion.div
      initial={{ opacity: 0, y: 8 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.35, delay: index * 0.05, ease }}
      className="flex items-center gap-3 rounded-xl bg-muted/40 px-4 py-4"
    >
      <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-accent/10 text-accent">
        {icon}
      </div>
      <div className="min-w-0">
        <div className={`text-sm font-semibold font-mono tabular-nums truncate ${valueClassName ?? "text-foreground"}`}>
          {value}
        </div>
        <div className="text-[11px] text-muted-foreground truncate">{label}</div>
      </div>
    </motion.div>
  );
}

export function StatRow({
  items,
}: {
  items: { label: string; value: string; valueClassName?: string }[];
}): ReactNode {
  return (
    <div className="grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-4">
      {items.map((item) => (
        <div
          key={item.label}
          className="flex min-w-0 flex-col items-center gap-1 rounded-xl border border-border/40 bg-card px-4 py-5 text-center"
        >
          <span className="block w-full truncate text-[11px] font-medium text-muted-foreground">
            {item.label}
          </span>
          <span
            className={`block w-full truncate font-mono text-xl font-semibold tabular-nums ${item.valueClassName ?? "text-foreground"}`}
          >
            {item.value}
          </span>
        </div>
      ))}
    </div>
  );
}
